import React from "react"
import { TouchableOpacity, View, Text } from "react-native"

const SelectType = (props) => {
    return <View>
        <TouchableOpacity onPress={() => {
            props.navigation.navigate('search_by_text')
        }}>
            <Text>Search Name</Text>
        </TouchableOpacity>
        <TouchableOpacity>
            <Text>By image</Text>
        </TouchableOpacity>
    </View>
}

export default SelectType